import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCheck, faChevronLeft, faEnvelope } from '@fortawesome/free-solid-svg-icons';

/**
 * Reservare zatím nemá veřejně publikované ceníky — produkt je v pilotní fázi
 * a každý salon dostává nasazení podle vlastních potřeb. Stránka existuje
 * jen pro případ, že někdo zabloudí na /site/prices z externího odkazu;
 * směruje rovnou na kontakt.
 */
const PricesPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-primary-50 to-white">
    <header className="bg-white shadow-sm">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
        <Link to="/site" className="flex items-center gap-3 text-gray-900 hover:text-primary-600 transition-colors">
          <div className="w-10 h-10 bg-gradient-to-r from-primary-600 to-primary-700 rounded-lg flex items-center justify-center text-white">
            <FontAwesomeIcon icon={faCalendarCheck} className="text-lg" />
          </div>
          <span className="text-xl font-bold">Reservare</span>
        </Link>
        <Link to="/site" className="text-sm text-gray-600 hover:text-primary-600 transition-colors">
          <FontAwesomeIcon icon={faChevronLeft} className="mr-1" /> Zpět
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="bg-white rounded-2xl shadow-xl p-10 text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Cena podle vašeho provozu</h1>
        <p className="text-lg text-gray-600 mb-8">
          Reservare je v aktivní pilotní fázi. Pro pilotní salony zdarma, pro produkční nasazení
          vám připravíme nabídku podle počtu poboček, zaměstnanců a integrací (WhatsApp,
          AI extrakce, vlastní hosting). Žádné překvapení v drobném písmu.
        </p>

        <div className="bg-gray-50 rounded-xl p-6 mb-8 text-left text-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Co se ptáme</h2>
          <ul className="space-y-2 text-sm">
            <li>• Kolik máte zaměstnanců a zda se mají objevovat v kalendáři</li>
            <li>• Jestli chcete přijímat zprávy přes WhatsApp a kdo bude reagovat</li>
            <li>• Zda chcete vlastní subdoménu / hosting nebo SaaS</li>
            <li>• Jaké e-maily / SMS máte v plánu posílat zákazníkům</li>
          </ul>
        </div>

        <a
          href="mailto:info@reservare.cz?subject=Zájem o Reservare"
          className="inline-flex items-center gap-3 bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors"
        >
          <FontAwesomeIcon icon={faEnvelope} />
          Napsat na info@reservare.cz
        </a>
        <p className="text-sm text-gray-500 mt-4">
          Nebo vyplňte <Link to="/site/contact" className="text-primary-600 hover:text-primary-700 underline">kontaktní formulář</Link>.
        </p>
      </div>
    </main>
  </div>
);

export default PricesPage;
